var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNavigatorSlider = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-1-1h39v22H-1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.812,
    rx: 4,
    fill: "#96ABBA",
    height: 20,
    width: 15,
    y: -0.062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.812 3.938v12m3-12v12",
    strokeLinecap: "round",
    stroke: "#59cdd5"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#e1e8ee",
    strokeLinecap: "undefined",
    strokeLinejoin: "undefined",
    strokeWidth: 3,
    fill: "none",
    d: "M20.312.094v20.062"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNavigatorSlider);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/navigator-slider.29229e5a6fa8700806abdb7f6188a971.svg";